import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/globals.css';
import './styles/animations.css';
import { initErrorReporter } from './shared/errorReporter.js';
import { initWebVitals } from './lib/metrics.js';
import { App } from './app/App.js';
import { Providers } from './app/Providers.js';

initErrorReporter();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <App />
    </Providers>
  </React.StrictMode>,
);

initWebVitals();
